import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'

import { FONTS, SPACES } from 'src/constants'

export const useStyles = makeStyles((theme: Theme) => ({
  listItem: {
    '&&': {
      padding: SPACES.xs,

      display: 'flex',
      alignItems: 'center',
    },
  },
  innerItem: {
    '&&': {
      display: 'flex',
      gap: SPACES.m,
      alignItems: 'center',
    },
  },
  itemText: {
    '&&': {
      flex: 1,

      fontSize: FONTS.SIZES.m,
      lineHeight: 1.337,
      color: theme.palette.custom.darkBlue2,
      fontWeight: FONTS.WEIGHTS.bold,

      textOverflow: 'ellipsis',
      overflow: 'hidden',
    },
  },
  image: {
    '&&': {
      display: 'block',

      borderRadius: 5,
      objectFit: 'cover',

      width: '60px',
      height: '60px',
      fill: theme.palette.custom.darkBlue2,
    },
  },
  addButton: {
    '&&': {
      display: 'flex',
      marginLeft: 'auto',
    },
  },
  collapseItemsWrapper: {
    '&&': {
      rowGap: SPACES.l,
      display: 'flex',
      flexDirection: 'column',

      paddingLeft: '3.5rem',
    },
  },
}))
